import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/purchases_16.svg';

export const IconPurchases16 = createIconComponent(Icon);
